import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Map } from 'immutable';

import ProgressImage from '../../../progress-image';

class Slide extends React.Component {
  goTo(e, link) {
    e.preventDefault();
    const { history, isChanging } = this.props;
    if (isChanging) return;
    history.push(link);
  }

  render() {
    const { block } = this.props;
    // const image = block.getIn(['fields', 'image', 'value', 'sizes', 'full', 'src']);
    const caption = block.getIn(['fields', 'caption', 'value']);
    const link = block.getIn(['fields', 'link', 'value']);
    // const slideStyle = {
    //   backgroundImage: `url(${image})`,
    // };
    const image = block.getIn(['fields', 'image', 'value']);


    const progress = image ? <ProgressImage image={image.toJS()} width="100%" height="100%" /> : null;

    if (link) {
      return (
        <a className="slide" href={link} onClick={e => this.goTo(e, link)}>
          {progress}
          <div className="caption">{caption}</div>
        </a>
      );
    }


    return (
      <div className="slide">
        {progress}
        <div className="caption">{caption}</div>
      </div>
    );
  }
}

Slide.propTypes = {
  block: PropTypes.instanceOf(Map).isRequired,
  history: PropTypes.object.isRequired,
  isChanging: PropTypes.bool.isRequired,
};

export default withRouter(Slide);



// WEBPACK FOOTER //
// ./src/components/blocks/carousel/slide/index.jsx